// ============================================================
//  lib/colors.ts — paleta de colores de nota (fuente única).
//  Las clases CSS asociadas viven en globals.css (.note-<key>) y se
//  adaptan a modo claro/oscuro. Aquí solo el catálogo y el contrato.
// ============================================================
export const NOTE_COLORS = [
  { key: "default", label: "Por defecto" },
  { key: "amber", label: "Ámbar" },
  { key: "rose", label: "Rosa" },
  { key: "sky", label: "Cielo" },
  { key: "emerald", label: "Menta" },
  { key: "violet", label: "Lavanda" },
  { key: "stone", label: "Arena" },
] as const;

export type NoteColor = (typeof NOTE_COLORS)[number]["key"];

export const NOTE_COLOR_KEYS = NOTE_COLORS.map((c) => c.key) as NoteColor[];

/** Normaliza el color almacenado (nullable) a una clave válida. */
export function resolveColor(color: string | null | undefined): NoteColor {
  return color && (NOTE_COLOR_KEYS as string[]).includes(color) ? (color as NoteColor) : "default";
}

/** Clase CSS del tinte de fondo para una nota. */
export function noteColorClass(color: string | null | undefined): string {
  return `note-${resolveColor(color)}`;
}
